<template>
  <section
    id="checkoutHotelDetails"
    :class="[openClass, 'expandable_section']"
  >
    <h2
      class="expandable_header"
      @click="updateSection(sectionName)"
    >
      {{ number }}. {{ $t('checkout.hotelDetails.sectionTitle') }}
    </h2>
    <div class="expandable_content">
      <div class="checkout-hotel">
        <p>{{ $t('checkout.hotelDetails.description') }}</p>
        <!-- Loop begins -->
        <div
          v-for="(room, index) in roomInformation"
          :key="index"
          class="room-information"
        >
          <p>
            <b>{{ $t('checkout.hotelDetails.room', {number: index + 1}) }}</b>
            {{ room.hotelName }}
          </p>
          <p
            v-if="room.checkIn && room.checkOut"
            class="small"
          >
            {{ room.checkIn }} - {{ room.checkOut }}
          </p>
          <div class="hotel-details-checkbox">
            <input
              :id="`billing-name-${index}`"
              v-model="sameAsBilling[index]"
              type="checkbox"
            >
            <label
              :for="`billing-name-${index}`"
              class="hotel-details-label"
            >
              Same as Billing Name
            </label>
          </div>
          <div class="required-field">
            <input
              v-model="room.name"
              v-validate="'required'"
              class="checkout-address"
              :name="`name-${index}`"
              type="text"
              placeholder="*Name for Reservation"
              :class="{ 'required': errors.has(`name-${index}`) && !sameAsBilling[index] }"
              :disabled="sameAsBilling[index]"
            >
            <span
              v-show="errors.has(`name-${index}`) && !sameAsBilling[index]"
              class="error"
            >
              {{ errors.first(`name-${index}`) }}
            </span>
          </div>
        </div>
        <!-- Loop Ends -->
      </div>
      <button
        class="continue-button btn btn-primary"
        @click="checkRequiredFields"
      >
        {{ $t('cookie.continue') }}
      </button>
    </div>
  </section>
</template>

<script>
import Api from '../cart/cart_api'

export default {
  props: {
    currentsection: {
      default: null,
      required: true,
      type: String
    },

    number: {
      default: null,
      required: false,
      type: Number
    },

    paymentfields: {
      default: null,
      type: Object
    }
  },

  data() {
    return {
      sectionName: 'hotel',
      sectionNext: 'review',
      sameAsBilling: [],
      roomInformation: [],
    }
  },

  computed: {
    selected() {
      return this.currentsection == this.sectionName
    },
    openClass() {
      return (this.selected) ? 'open' : ''
    }
  },

  watch: {
    roomInformation() {
      this.$emit('payment-fields-update', { roomInformation: this.roomInformation})
    },
    paymentfields() {
      this.updateReservationName()
    },
    sameAsBilling() {
      this.updateReservationName()
    }
  },

  created() {
    this.getOrder()
  },

  methods: {
    async updateSection(section) {
      this.$emit('section-update', section)
    },
    async getOrder() {
      let order = await Api.getOrder()

      let orderItems = order.items
      orderItems.forEach(item => {
        for (let i = 0; i < item.room_quantity; i++) {
          this.roomInformation.push({
            orderItemId: item.id,
            numberOfAdults: 2,
            name: null,
            hotelName: item.hotel_display_name,
            checkIn: item.h4h_hotel_attributes.hotel_check_in_date,
            checkOut: item.h4h_hotel_attributes.hotel_check_out_date
          })
          this.sameAsBilling.push(false)
        }
      })

      this.roomInformation.length > 0 ?
        this.$emit('hotels-in-cart', true) :
        this.$emit('hotels-in-cart', false)
    },
    updateReservationName() {
      for (let i = 0; i < this.sameAsBilling.length; i ++) {
        if (this.sameAsBilling[i]) {
          let name = `${this.paymentfields.firstName} ${this.paymentfields.lastName}`
          this.roomInformation[i].name = name
        }
      }
    },
    async checkRequiredFields() {
      let isValid = await this.$validator.validate()
      if (isValid) {
        this.updateSection(this.sectionNext)
      } else {
        for (let field of this.$validator.fields) {
          field.update({ events: 'input|blur'})
        }
      }
    }
  }
}
</script>
